<!-- 产品类别 -->
<template>
  <BaseFormItem2
    class="board_type"
    :label="fields.label"
    :labelTips="fields.labelTips"
  >
    <BaseRadioGroup2 v-model="val" @change="handleEmit">
      <BaseTipPopover 
        class="board_type__radio"
        placement="top"
        v-for="item in options"
        :key="item.value" 
        :content="item.tips" 
        :disabled="!item.tips"
      >
        <el-radio
          slot="reference"
          border
          :label="item.value"
          @click.native.prevent="handleItemClick(item.value)"
        >
          {{ item.label }}
          <img 
            v-if="item.value == 'CEM-1'"
            class="board_type__radio__new" 
            :src="require('@@/assets/img/icons/icon_new.png')" 
          />
        </el-radio>
      </BaseTipPopover>
    </BaseRadioGroup2>
  </BaseFormItem2>
</template>

<script>
import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: String,
      default: 'FR-4'
    },
  },
  data() {
    return {
      val: this.value
    }
  },
  computed: {
    fields() {
      return getFR4Fields('board_type')
    },
    options() {
      const options = this.fields.options
      
      // 暂时隐藏 铝基板 铜基板
      const aluOrCopper = { 
        ALU: [{ value: 'ALU', label: '铝基板' }],
        COPPER: [{ value: 'COPPER', label: '铜基板' }]
      }[this.value] || []

      return [...options, ...aluOrCopper]
    }
  },
  watch: {
    value(newVal) {
      // this.val = newVal
      this.handleItemClick(newVal, false)
    },
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
    },
    handleItemClick(board_type, needEmit = true) {
      this.val = board_type
      needEmit && this.handleEmit()
    }
  }
}
</script>

<style lang="scss" scoped>
.board_type ::v-deep {
  .base-radio-group {
    margin-bottom: -10px;
    .el-radio.is-bordered {
      margin-bottom: 10px;
    }
    .el-radio.is-bordered {
      margin-left: 0;
      margin-right: 10px;
    }
  }
}
.board_type__radio {
  position: relative;
  .board_type__radio__new {
    position: absolute;
    top: -10px;
    right: 6px;
  }
}
</style>